import { render } from "./VehicleSupplyOrder.vue?vue&type=template&id=08ad1fbe&scoped=true"
import script from "./VehicleSupplyOrder.vue?vue&type=script&lang=js"
export * from "./VehicleSupplyOrder.vue?vue&type=script&lang=js"

import "./VehicleSupplyOrder.vue?vue&type=style&index=0&id=08ad1fbe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ad1fbe"]])

export default __exports__